/**
 * Created by emilgrabowiec on 17.03.2016.
 */
require('../../search/_submit');
const LicenseInfoService = require('./LicenseInfoService');

$(() => {
  $('.tagsinput').tagsInput({
    interactive: false,
    delimiter: '|'
  });

  $('.select-hymnal').select2({
    placeholder: __('Hymnals / Resources')
  });

  $('.select-licenseType').select2({
    placeholder: __('Select License Type'),
    minimumResultsForSearch: Infinity
  });

  $('#bulk-action').select2({
    placeholder: __('Select Action'),
    minimumResultsForSearch: Infinity,
    width: '100%'
  });

  $('.report-year').select2({
    placeholder: __('Select Year'),
    minimumResultsForSearch: Infinity,
    width: '100%'
  });

  if ($('.select-licenseType').length) {
    $('.duplicate').select2({
      placeholder: __('Select Week'),
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    $('.duplicate').select2({
      placeholder: __('Select Week'),
      minimumResultsForSearch: Infinity
    });
  }

  $('.duplicate').on('select2:close', function (e) {
    const idReprint = $('.select-licenseType').find('option:selected').val();
    const data = $(this).select2('data')[0];
    $('.tagsinput').addTag(`${data.id}_${idReprint}`, data.text, { unique: true });
  });


  $('#duplicateModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);
    const id = btn.data('registration');

    $('#submit-duplicate').data('id', id);
  });

  $('#duplicateForm').submit((e) => {
    e.preventDefault();
  });

  $('.select-licenseType').on('select2:select', function (e) {
    const selectedOption = $(this).find('option:selected');
    const id = selectedOption.val();
    const colReportType = $('.col-report-type');
    const colNumServices = $('.col-num-services');
    const isReprintWithPodcast = selectedOption.data('is-reprint-with-podcast');

    if (isReprintWithPodcast) {
      colNumServices.removeClass('col-md-12');
      colNumServices.addClass('col-md-6');
      colReportType.show();
    } else {
      colNumServices.addClass('col-md-12');
      colNumServices.removeClass('col-md-6');
      colReportType.hide();
    }

    $('.time-report').select2('val', '');
    $('.time-report').select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: __('loading...')
    });

    LicenseInfoService.loadWeeks(id).success((data) => {
      $('.time-report option').remove();

      $.each(data.weeks, (i, item) => {
        $('.time-report').append($('<option>', {
          value: i,
          text: item
        }));
      });

      $('.time-report').select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });
    });
  });

  $('.text-green').popover({
    placement: 'bottom',
    content: __('You will not be reminded to report this week'),
    trigger: 'hover'
  });

  $('#submit-duplicate').click(function (e) {
    const btnRfc = $(this);
    const id = $(this).data('id');
    const weekSpans = $('#duplicateForm').find('span.selected-report-date');
    const weeks = new Array();

    weekSpans.each(function (index) {
      weeks.push($(this).data('id'));
    });

    if (weeks.length > 0) {
      btnRfc.button('loading');

      $.post(duplicateReportUrl, {
        id,
        weeks
      }, (data, b) => {
        btnRfc.button('reset');

        if (data.isError === 1) {
          toastr.error(data.msgError, 'Error');
        } else {
          location.reload();
        }
      });
    } else {
      toastr.error(__('Please select weeks to report for.'), 'Error');
    }

    e.preventDefault();
  });

  $('#NumServiceModal').modal('show');

  $('#NumServiceModal #saveOS').click(function () {
    const btn = $(this);
    btn.loading();

    $.post(changeServiceUrl, {
      value: $('#num_services').val()
    }).success(() => {
      $('#NumServiceModal').modal('hide');
      toastr.success(__('Service has been successfully updated'), __('Success'));
    }).always(() => {
      btn.loading('reset');
    });
  });

  $('button[name="submit-bulk"]').click(function () {
    const registrations = new Array();
    const btnRfc = $(this);

    $('.main-container').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        registrations.push($(this).val());
      }
    });

    btnRfc.button('loading');

    $.post(bulkActionUrl, {
      bulkAction: $('#bulk-action').val(),
      data: JSON.stringify(registrations)
    }, (data, b) => {
      btnRfc.button('reset');

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        for (let i = 0; i < data.updatedRegs.length; i++) {
          const elem = $(`#reg-${data.updatedRegs[i]}`).parent().parent().parent()
              .find('.reported-info');

          switch (data.action) {
            case 'mark':
              elem.removeClass('text-red');

              var checks = elem.find('.fa');

              if (checks.length == 0) {
                elem.append(' <i class="fa fa-check" aria-hidden="true"></i>');
              }

              break;
            case 'unmark':
              if (elem.text().match('0 Reported')) {
                elem.addClass('text-red');
              }

              elem.find('.fa').remove();
              break;
          }
        }

        $('.reported-info').popover('destroy');

        $('.text-green').popover({
          placement: 'bottom',
          content: __('You will not be notified about this week anymore.'),
          trigger: 'hover'
        });

        /* uncheck checkboxes */
        $('.main-container').find('input[type="checkbox"]').each(function () {
          if ($(this).is(':checked')) {
            $(this).attr('checked', false);
          }
        });

        toastr.success(__('Report succesfully updated.'), __('Success'));
      }
    });
  });

  $('#print-year-report-btn').click(function (e) {
    e.preventDefault();
    const organizationId = $(this).data('id');
    const year = $('.report-year').val();

    $.get(`${urlYearReport.slice(0, -2)}/${organizationId}/${year}`, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        window.location = '/my-account?tab=downloads';
      }
    }, 'json');
  });
});
